export default "__VITE_ASSET__BBNQ6l2y__"